import './MobileStickyFullLayout.scss';
import { isDefaultBrand, useConfig } from '@travelwin/core';
import classNames from 'classnames';

const className = 'c-MobileStickyFullLayout';
const MobileStickyFullLayout = ({
  children,
  isExpanded,
}: {
  children: React.ReactNode;
  isExpanded: boolean;
}) => {
  const { WHITELABEL_BRAND } = useConfig();

  return (
    <div
      className={classNames(`${className}__wrapper`, {
        [`${className}__wrapper--default-brand`]:
          isDefaultBrand(WHITELABEL_BRAND),
      })}
    >
      <div
        className={classNames(`${className}__container`, {
          [`${className}__container--open`]: isExpanded,
          [`${className}__container--open--default-brand`]:
            isExpanded && isDefaultBrand(WHITELABEL_BRAND),
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default MobileStickyFullLayout;
